<template>
    <v-dialog v-model="dialog" scrollable max-width="600px" hide-overlay>
        <template v-slot:activator="{ on }">
            <v-btn color="secondary" small icon v-on="on">
                <v-tooltip bottom color="primary">
                    <template v-slot:activator="{ on }">
                        <v-icon small v-on="on">mdi-pencil</v-icon>
                    </template>
                    <span>edit chain</span>
                </v-tooltip>
            </v-btn>
        </template>
        <v-card v-if="!loading">
            <v-card-title class="subtitle-2 pt-6 text-pre-wrap">
                New  parameters of <span class="secondary--text">{{ chain.name }}</span>  
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="black--text">
                <v-container grid-list-md>
                    <v-form v-model="valid" ref="form" validation>
                        <v-row>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="Chain name" 
                                    v-model="name" name="name"
                                    type="text" :rules="[rules.required]">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-select dense color="primary" label="Type of chain" v-model="type" :items="types"
                                    :rules="[rules.required]" @change="onceMore()">
                                </v-select>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="Number of stores" v-model.number="stores"
                                    name="stores" type="text" :rules="[rules.required]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="Peak market coverage"
                                    v-model.number="peak_market_coverage" name="peak_market_coverage" type="text"
                                    :rules="[rules.required, rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="Entry fee" v-model.number="entry_fee"
                                    name="entry_fee" type="text" :rules="[rules.required, rules.number]"
                                    @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="Annual fee" v-model.number="annual_fee"
                                    name="annual_fee" type="text" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="Retail margin" v-model.number="retail_margin"
                                    name="retail_margin" type="text" :rules="[rules.required, rules.number]"
                                    @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="Number of trademarks"
                                    v-model.number="num_trademarks" name="num_trademarks" type="text"
                                    :rules="[rules.required, rules.number]" @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="Max price" v-model.number="priceMax"
                                    name="priceMax" type="text" :rules="[rules.required, rules.number]"
                                    @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="Min price" v-model.number="priceMin"
                                    name="priceMin" type="text" :rules="[rules.required, rules.number]"
                                    @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <!--design-->
                            <v-col cols="12" sm="6" md="4">
                                <v-select dense color="primary" label="Main design" v-model="design_main"
                                    :items="designTypes" :rules="[rules.required]" @change="onceMore()">
                                </v-select>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-select dense color="primary" label="Second design" v-model="design_second"
                                    :items="designTypes" :rules="[rules.required]" @change="onceMore()">
                                </v-select>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-container>
                <v-row justify="center" class="error--text">{{ error }}</v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text class="text-capitalize" @click="closeDialog">
                    Close
                </v-btn>
                <v-btn color="primary" text class="text-capitalize" :disabled="!haveBeenChanged || Boolean(error)"
                    @click="addChain">Save</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'EditChain',
    props: ['chain'],
    data() {
        return {
            dialog: false,
            valid: false,
            error: '',
            haveBeenChanged: false,
            rules: {
                required: v => !!v || 'this field is required',
                number: v => /^[+]?[0-9]/.test(v) || 'it\'s expected number'
            },
            designTypes: ['classic', 'business', 'casual', 'innovative', 'art'],
            types: ['online', 'brick&mortar'],
            name: this.chain.name,
            type: this.chain.type,
            stores: this.chain.stores,
            peak_market_coverage: this.chain.peak_market_coverage,
            entry_fee: this.chain.entry_fee,
            annual_fee: this.chain.annual_fee,
            retail_margin: this.chain.retail_margin,
            num_trademarks: this.chain.num_trademarks,
            priceMax: this.chain.max_price,
            priceMin: this.chain.min_price,

            design_main: this.chain.design_main,
            design_second: this.chain.design_second,

        }
    },
    computed: {
        loading() {
            return this.$store.getters.loading
        }
    },
    methods: {

        onceMore() {
            this.error = ''
            this.haveBeenChanged = true
        },
        async addChain() {

            if (this.$refs.form.validate()) {
                const chain = {
                    id: this.chain.id,
                    gameId: this.chain.gameId,
                    name: this.name,
                    type: this.type,
                    stores: this.stores,
                    peak_market_coverage: this.peak_market_coverage,
                    entry_fee: this.entry_fee,
                    annual_fee: this.annual_fee,
                    retail_margin: this.retail_margin,
                    num_trademarks: this.num_trademarks,
                    max_price: this.priceMax,
                    min_price: this.priceMin,
                    design_main: this.design_main,
                    design_second: this.design_second,
                }

                try {
                    //edit segment 
                    await this.$store.dispatch('editChain', chain)
                    this.closeDialog()
                }
                catch (error) {
                    this.$store.dispatch('setError', error.message)//throw error
                }
            }
        },
        closeDialog() {
            //reset
            this.dialog = false;
            this.error = '';
            this.haveBeenChanged = false
            this.name = this.chain.name
            this.type = this.chain.type
            this.stores = this.chain.stores
            this.peak_market_coverage = this.chain.peak_market_coverage
            this.entry_fee = this.chain.entry_fee
            this.annual_fee = this.chain.annual_fee
            this.retail_margin = this.chain.retail_margin
            this.num_trademarks = this.chain.num_trademarks
            this.priceMax = this.chain.max_price
            this.priceMin = this.chain.min_price
            this.design_main = this.chain.design_main
            this.design_second = this.chain.design_second
        }
    }
}
</script>